<template>
  <div class="tw:flex tw:items-center tw:justify-center">
    <div
      class="tw:flex tw:items-center tw:gap-2 tw:bg-blue-100 tw:text-blue-700 tw:text-sm tw:rounded-sm tw:leading-tight"
      :class="computedClass"
    >
      <div class="tw:flex tw:items-center tw:justify-center">
        <BaseIcon
          class="tw:text-4"
          icon="filter-set"
        />
      </div>
      <span
        v-if="!hideLabel"
        class="tw:whitespace-nowrap tw:font-roboto"
        >{{ getLocaleText("stream_filters_applied.filters_applied") }}</span
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseIcon } from "shared/components/base";

interface StreamFiltersAppliedProps {
  hideLabel?: boolean;
  size?: "sm" | "md";
}

const SIZE_CLASSES = {
  sm: {
    "tw:min-h-(--s-size-controls-sm)": true,
    "tw:min-w-(--s-size-controls-sm)": true,
  },
  md: {
    "tw:min-h-(--s-size-controls-md)": true,
    "tw:min-w-(--s-size-controls-md)": true,
    "tw:py-1": true,
  },
};

const props = withDefaults(defineProps<StreamFiltersAppliedProps>(), {
  size: "md",
});

const computedClass = computed(() => ({
  "tw:justify-center": props.hideLabel,
  "tw:px-2": !props.hideLabel,
  ...SIZE_CLASSES[props.size],
}));
</script>
